import * as React from "react";
import type { SVGProps } from "react";
const SvgSubtractIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="subtract_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333zM755.5 398.507 456.832 682.965a44.203 44.203 0 0 1-60.33 0l-128-121.898a39.253 39.253 0 0 1 0-57.472 44.203 44.203 0 0 1 60.33 0l97.835 93.141 268.501-255.701a44.203 44.203 0 0 1 60.33 0 39.253 39.253 0 0 1 0 57.472z"
    />
  </svg>
);
export default SvgSubtractIcon;
